import $ from "jquery";
import 'bootstrap'
import styles from '/assets/scss/app.scss';
import scripts from '/js/app.js';
import 'readmore-js';

import AOS from 'aos';
import 'aos/dist/aos.css';



//FIRST STEP
$('.first-step .je-suis .wpcf7-list-item-label').click(function (){
    $('.first-step .je-suis .wpcf7-list-item-label').removeClass("active");
    $(this).addClass("active");
});

$('.first-step .lieu .wpcf7-list-item-label').click(function (){
    $('.first-step .lieu .wpcf7-list-item-label').removeClass("active");
    $(this).addClass("active");
});

//SECOND STEP
$('.second-step .thematique label').click(function (){
    $('.second-step .thematique label').removeClass("active");
    $(this).addClass("active");
});

//THIRD STEP
$('.third-step .contact .wpcf7-list-item-label').click(function (){
    $('.third-step .contact .wpcf7-list-item-label').removeClass("active");
    $(this).addClass("active");
});

$('.third-step .news .wpcf7-list-item-label').click(function (){
    $('.third-step .news .wpcf7-list-item-label').removeClass("active");
    $(this).addClass("active");
});

$('.third-step .your-consent .wpcf7-list-item-label').click(function (){
    $('.third-step .your-consent .wpcf7-list-item-label').removeClass("active");
    $(this).addClass("active");
});


//SEND FORM + HIDE
$('.wpcf7-submit').click(function (){
    $('.wpcf7-form').addClass('hiding');
    $('.fourth-step').addClass('active');
    $('.fourth-step-progress').addClass('active');
})

//SUBMIT LISTENER
$('.wpcf7-submit').on('click', function (e){
    e.preventDefault()
    $('html,body').animate(
        {
            scrollTop: $('#thanks').offset().top - 150,
        },500
    )
})

//GO TO FORM
$('.home a[href*="#"]').on('click', function (e) {
    e.preventDefault()

    $('html, body').animate(
        {
            scrollTop: $($(this).attr('href')).offset().top - 50,
        },
        500,
        'linear'
    )
    $('.navbar-collapse').removeClass('active');
    $('body').removeClass('active')
    $('.hamburger').removeClass("is-active");
})

//BURGER MENU
$('.navbar-toggler').click(function (){
    $('.navbar-collapse').toggleClass('active');
    $('body').toggleClass('active')
})
$(document).ready(function(){
    $(".hamburger").click(function(){
        $(this).toggleClass("is-active");
    });
});

//READMORE

$('.more').click(function (){
    $(this).prev().toggleClass('active');
})

//FILE INPUT
$('.wpcf7-file').change(function() {
    var i = $('.upload > p').first().clone();
    var file = $('.wpcf7-file')[0].files[0].name;
    $('.upload > p').first().text(file);
    $('.upload > p').first().css({"color": "#52B299", "text-transform": "uppercase", "font-weight": "600"})
});


//FOLLOW ACTIVE LINK
/*let menuScrollTimer = null;*/
// Detect how far are we from the top of the page
/*$(window).scroll(function (e) {*/
    // Avoid triggering the logic if the scroll event is triggerd from clicking one of the items
    /*if (menuScrollTimer === null) {
        let windowTop = $(this).scrollTop();

        $('a.nav-link').each(function (event) {
            if (windowTop >= $($(this).attr('href')).offset().top - 100) {*/
                //
                // $('.site_header_main-navigation ul li.active:not(:last-of-type)').removeClass('active');
                /*$(this).addClass('active');

            }else{
                $(this).removeClass('active');
            }
        });*/

        //$('.site_header_main-navigation ul li.active').not(':last').removeClass('active');
/*    }
});*/

/*$('.navbar-collapse ul li a').on('click',function(e){
    $('.navbar-collapse ul li a').removeClass('active');
    $(this).addClass('active');
});*/

$(document).ready(function(){

    var sectionIds = $('.navbar-nav .nav-item a.navigation');

    $(document).scroll(function(){
        sectionIds.each(function(){

            var container = $(this).attr('href');
            var containerOffset = $(container).offset().top;
            var containerHeight = $(container).outerHeight();
            var containerBottom = containerOffset + containerHeight;
            var scrollPosition = $(document).scrollTop();
            var test = $(window).scrollTop() + $(window).height();

            if(test < containerBottom + 20 && test >= containerOffset + 20){
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }

        });
    });



});

AOS.init();







